var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,20.608C40,9.494 31.046,0.486 20,0.486C8.954,0.486 0,9.494 0,20.606C0,30.652 7.314,38.976 16.876,40.486L16.876,26.426L11.796,26.426L11.796,20.606L16.876,20.606L16.876,16.174C16.876,11.132 19.86,8.346 24.43,8.346C26.618,8.346 28.906,8.738 28.906,8.738L28.906,13.69L26.386,13.69C23.9,13.69 23.126,15.242 23.126,16.834L23.126,20.608L28.672,20.608L27.786,26.424L23.126,26.424L23.126,40.484C32.686,38.976 40,30.652 40,20.608Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.b1cccae66066fee26882ee9d040bd5d7.svg";
export { ForwardRef as ReactComponent };